import { Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, EventType, Router } from '@angular/router';
import { TranslatableKey } from '@app/types/translatable.type';
import { ReportingModuleMenuService } from '../../services/reporting-module-menu.service';

@Component({
    templateUrl: './reporting-router.template.html',
    styles: [
        `
            router-outlet {
                display: contents;
            }
        `,
    ],
})
export class ReportingRouterView {
    title?: TranslatableKey;

    constructor(
        public menuService: ReportingModuleMenuService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        this.router.events.pipe(takeUntilDestroyed()).subscribe((routerEvent) => {
            if (routerEvent.type === EventType.NavigationEnd) {
                this.title = this.route.firstChild?.snapshot.data.title ?? this.route.snapshot.data.title;
            }
        });
    }
}
